import React, {useState, useEffect, useCallback} from 'react';
import styled from 'styled-components';

import * as actions from '../../../redux/actions/TreadmillsActions'
import {Input} from "../../ira/ui/Inputs";
import NiceModal from "../../modals/NiceModal";
import Tabs from "../../ui/Tabs";
import TreadmillEditor from "../treadmill/editor/TreadmillEditor";
import SmartTreadmillPlayerTool from "../treadmill/tools/SmartTreadmillPlayerTool";
import UpdateTreadmillForm from "../treadmill/forms/UpdateTreadmillForm";

import {Button} from "../../ui/Button";
import {useMappedState, useDispatch} from "redux-react-hook";
import {translate} from "../../../utils/Translate";
import tick_img from "../../../assets/img/green_check.svg";
import {Set} from "immutable";
import {hasIntersection} from "../../exercises/panels/AllExercisesPanel";
import {GreenButton, RedButton} from "../../ira/ui/Buttons";
import CommonHelper from "../../../helpers/CommonHelper";
import share_img from "../../../assets/img/share_mini.svg";
import pause_img from "../../../assets/img/pause_button.svg";
import play_img from "../../../assets/img/play_button.svg";
import replay_img from "../../../assets/img/replay_button.svg";
import {func} from "prop-types";
import toast from "react-hot-toast";
import {isMobile} from "polotno/utils/screen";

//todo: refactor, optimize copy-paste

export default function TreadmillsSimpleListPanel(props) {
    const {
        mode = 'my',
        selectMode = false,
        onSelect = x => {

        },
        selectedSet = Set(),
        treadmillsIds = []
    } = props;

    const dispatch = useDispatch();

    const [addModalVisible, setAddModalVisible] = useState(false);
    const [selectedTreadmillId, setSelectedTreadmillId] = useState(undefined);
    const [text, setText] = useState('');
    const [copyModalVisible, setCopyModalVisible] = useState(false);
    const [copyName, setCopyName] = useState('');

    const [currentTime, setCurrentTime] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const [videoTimeFromStart, setVideoTimeFromStart] = useState(0);

    function setPause(value) {
        setIsPaused(value);
    }

    function setTime(value) {
        setCurrentTime(value);
    }

    // useEffect(() => {
    //     dispatch(actions.loadTreadmills());
    // }, []);

    useEffect(() => {
        if (props.treadmillsIds == undefined || props.treadmillsIds.length == 0){
            return;
        }else{
            dispatch(actions.loadTreadmillsByIds(props.treadmillsIds));
        }
    }, [props.treadmillsIds == undefined ? '' : props.treadmillsIds.join('_')]);

    useEffect(() => {
        if (currentTime >= treadmillTime) {
            setIsPaused(true);
        }
    })

    const {
        treadmills = [],
        user,
        loading = false,
        currentUserId,
        isInitialized
    } = useMappedState(useCallback(state => {
        let {currentUserId} = state.users;
        let currentUser = state.users.usersMap.get(currentUserId);
        let allTreadmills = state?.treadmills?.treadmillsMap.toArray();
        // let exercises = (mode == 'my') ? allTreadmills.filter(x => (x.creatorId == currentUserId)) : allTreadmills;
        // let exercises = (mode == 'my') ? allTreadmills.filter(x => (x.creatorId == currentUserId)) : allTreadmills;
        let exercises = allTreadmills.filter(x => ((props.treadmillsIds || []).indexOf(x.id) > -1));

        let aGroups = state.accessGroups.accessGroupsMap.toArray().filter(x => ((x?.emails || []).indexOf(currentUser.email) == -1 && x?.creatorId != currentUserId));
        let aGroupsIds = aGroups.map(xx => xx?.id).filter(x => (x != undefined));
        // if (mode == 'shared') {
        //     exercises = exercises.filter(x => hasIntersection((x?.accessGroupsIds || []), aGroupsIds));
        // }
        // if (mode == 'public') {
        //     // exercises = exercises.filter(x => (x?.access == 'public'));
        //     exercises = exercises;
        // }

        return {
            isInitialized: state.users.isInitialized,
            user: state.users.usersMap.get(state.users.currentUserId),
            treadmills: exercises,
            loading: state.treadmills.loading,
            currentUserId: state.users?.currentUserId
        }
    }));

    useEffect(() => {
        dispatch(actions.loadTreadmills());
        setTime(0);
        setIsPaused(false);
    }, []);

    let selectedTreadmill = (selectedTreadmillId == undefined) ? undefined : treadmills.filter(q => (q.id == selectedTreadmillId))[0];
    let treadmillTime = selectedTreadmill?.items === undefined || selectedTreadmill?.items?.length === 0 ? 0 : selectedTreadmill?.items.at(-1).to;
    const [showTime, setShowTime] = useState(selectedTreadmill?.showTime === undefined ? false : selectedTreadmill?.showTime);

    let fArr = treadmills;
    if (text != '') {
        fArr = fArr.filter(x => (x.name != undefined && (x.name.toLowerCase().indexOf(text.toLowerCase()) > -1)))
    }

    useEffect(() => {
        setShowTime(selectedTreadmill?.showTime === undefined ? false : selectedTreadmill?.showTime);
    }, [selectedTreadmill]);

    return (
        <Wrapper className={''}>

            {fArr.map((q, k) => {
                let isSelected = selectedSet.has(q.id);
                return (
                    <Quarter key={q.id} onClick={() => {

                    }}>
                        <Name onClick={() => {
                            setSelectedTreadmillId(q.id);
                        }}>
                            {q.name}
                        </Name>
                        {selectMode == false ? null :
                            <div style={{
                                marginTop: 10,
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center'
                            }}>
                                {isSelected == false ? null :
                                    <img src={tick_img} style={{height: 18, marginRight: 5}}/>
                                }
                                <SelectSpan onClick={() => {
                                    onSelect(q);
                                }}>
                                    {translate('select')}
                                </SelectSpan>
                            </div>
                        }
                    </Quarter>
                )
            })}


            {selectedTreadmill == undefined ? null :
                <NiceModal className={'zIndex2'} width={Math.min(1200, window.innerWidth)}
                           onClose={() => {
                               setSelectedTreadmillId(undefined);
                           }}>

                    {selectedTreadmill == undefined ? null :
                        <div style={{width: window.innerWidth >= 720 ? '1200px' : '75vw', height: `calc(100vh - 120px)`}}>
                            <Tabs
                                tabs={[
                                    {
                                        label: 'Информация',
                                        content: (
                                            <TabContent>
                                                <UpdateTreadmillForm {...selectedTreadmill}
                                                                     loading={loading}
                                                                     canUpdate={(mode == 'my')}
                                                                     onUpdate={async d => {
                                                                         await dispatch(actions.updateTreadmill({
                                                                             ...selectedTreadmill,
                                                                             ...d
                                                                         }));
                                                                     }}/>
                                            </TabContent>
                                        )
                                    },
                                    (mode != 'my') ? null :
                                        {
                                            label: 'Редактор',
                                            content: (
                                                <div>
                                                    {isMobile() == true ?
                                                        <div style={{
                                                            witdh: '100%',
                                                            height: '100%', display: 'flex',
                                                            justifyContent: 'center', alignItems: 'center',
                                                            fontWeight: 'bold', fontSize: '30px'
                                                        }}>
                                                            <div>
                                                                Редактирование тредмилов возможно только с компьютера
                                                            </div>
                                                        </div>

                                                        :

                                                        <TabContent style={{height: 'calc(100% - 50px)'}}>
                                                            <div style={{
                                                                height: `calc(100vh - 180px)`
                                                            }}>
                                                                <TreadmillEditor
                                                                    loading={loading}
                                                                    {...selectedTreadmill}
                                                                    onSave={async arr => {
                                                                        await dispatch(actions.updateTreadmill({
                                                                            id: selectedTreadmill.id,
                                                                            items: arr
                                                                        }));
                                                                        toast('Сохранено');
                                                                    }}/>
                                                            </div>
                                                        </TabContent>
                                                    }
                                                </div>
                                            )
                                        },
                                    {
                                        label: 'Превью',
                                        content: (
                                            <div>
                                                {isMobile() == true ?
                                                    <div style={{
                                                        witdh: '100%',
                                                        height: '100%', display: 'flex',
                                                        justifyContent: 'center', alignItems: 'center',
                                                        fontWeight: 'bold', fontSize: '30px'
                                                    }}>
                                                        <div>
                                                            Использование тредмилов возможно только с компьютера
                                                        </div>
                                                    </div>

                                                    :

                                                    <TabContent className={'treadmill_placeholder'} style={{
                                                        height: 'calc(100% - 50px)',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'}}>


                                                    <div style={{
                                                        height: `calc(100vh - 220px)`
                                                    }}>
                                                        <TreadmillPlaceholder>
                                                            <SmartTreadmillPlayerTool
                                                                loading={loading}
                                                                timerValue={currentTime}
                                                                setTime={setTime}
                                                                setPause={setPause}
                                                                isPaused={isPaused}
                                                                isPreview={true}
                                                                videoTimeFromStart={videoTimeFromStart}
                                                                {...selectedTreadmill} />
                                                        </TreadmillPlaceholder>

                                                        {treadmillTime === 0 ? null :
                                                            <TreadmillControls>
                                                                <PauseButton src={treadmillTime <= currentTime ? replay_img : isPaused ? play_img : pause_img}
                                                                             onClick={() => {
                                                                                 if (treadmillTime <= currentTime) {
                                                                                     setCurrentTime(0);
                                                                                     setVideoTimeFromStart(0);
                                                                                     setIsPaused(false);
                                                                                 } else {
                                                                                    setIsPaused(!isPaused);
                                                                                 }
                                                                             }}>

                                                                </PauseButton>
                                                                <Slider type='range' min='0' max={treadmillTime} value={currentTime}
                                                                        onChange={(evt) => {
                                                                            setCurrentTime(evt.target.value);
                                                                            setVideoTimeFromStart(evt.target.value);
                                                                        }}></Slider>
                                                                <div style={{display: 'flex', width: '80px', justifyContent: 'flex-end'}}>
                                                                    {Math.floor(currentTime / 60)}:
                                                                    {currentTime % 60 < 10 ? '0' + currentTime % 60 : currentTime % 60} / {Math.floor(treadmillTime / 60)}
                                                                    :{treadmillTime % 60 < 10 ? '0' + treadmillTime % 60 : treadmillTime % 60}
                                                                </div>
                                                            </TreadmillControls>
                                                        }
                                                            <ShareExecisePlaceholder>
                                                                <ShareLinkSpan onClick={() => {
                                                                    CommonHelper.linkTo(`/share/treadmills/${selectedTreadmill?.id}`, true);
                                                                }}>
                                                                    <ShareImg src={share_img}/>
                                                                    {translate('share_treadmills')}
                                                                </ShareLinkSpan>
                                                            </ShareExecisePlaceholder>
                                                        </div>
                                                    </TabContent>
                                                }
                                            </div>
                                        )
                                    },
                                    (mode != 'my') ? null :
                                        {
                                            label: 'Дополнительные настройки',
                                            content: (
                                                <TabContent style={{height: 'calc(100% - 50px)'}}>
                                                    <div style={{display: 'flex', gap: '10px'}}>
                                                        <div>Отображение времени для студента</div>
                                                        <ToggleInput type="checkbox" id="switch" checked={showTime} onChange={async (evt) => {
                                                            let s = !showTime;
                                                            setShowTime(s);
                                                            await dispatch(actions.updateTreadmill({
                                                                ...selectedTreadmill,
                                                                showTime: s
                                                            }));
                                                        }}/>
                                                        <ToggleLabel htmlFor="switch">Toggle</ToggleLabel>
                                                    </div>

                                                    <GreenButton style={{width: 'fit-content', marginTop: '20px'}} onClick={() => {
                                                        // setAddModalVisible(false);
                                                        setCopyModalVisible(true);
                                                    }}>
                                                        Сделать копию
                                                    </GreenButton>

                                                    {currentUserId !== selectedTreadmill.creatorId ? null :
                                                        <RedButton style={{width: 'fit-content', marginTop: '20px'}}
                                                                   onClick={async () => {
                                                                       let deleteConfirm = window.confirm("Вы уверены, что хотите удалить тредмил?");
                                                                       if (deleteConfirm === true) {
                                                                           await dispatch(actions.deleteTreadmill(selectedTreadmillId));
                                                                           setSelectedTreadmillId(undefined);
                                                                       }
                                                                   }}>
                                                            Удалить тредмил
                                                        </RedButton>
                                                    }
                                                </TabContent>
                                            )
                                        }
                                ].filter(x => (x != undefined))}
                            />
                        </div>
                    }

                </NiceModal>
            }


            {addModalVisible == false ? null :
                <NiceModal width={720} onClose={() => {
                    setAddModalVisible(false);
                }}>

                    <ModalInner>
                        {/* <ModalInner style={{width: 720}}>  */}

                        <UpdateTreadmillForm name={''} loading={loading} onUpdate={async d => {
                            let pld = await dispatch(actions.createTreadmill({
                                ...d,
                                creatorId: currentUserId
                            }));
                            setAddModalVisible(false);
                            setSelectedTreadmillId(pld.treadmill.id);
                        }}/>

                    </ModalInner>

                </NiceModal>
            }

            {copyModalVisible === false ? null :
                <NiceModal onClose={() => {
                    setCopyModalVisible(false);
                }}>
                    <CopyModalInner>
                        <div>Введите название копии</div>
                        <Input placeholder="Введите название копии" value={copyName} onChange={(evt) => {
                            let s = evt.target.value;
                            setCopyName(s);
                        }}/>

                        <GreenButton onClick={async () => {
                            let dd = JSON.parse(JSON.stringify(selectedTreadmill));
                            delete dd.id;
                            delete dd.timestamp;
                            delete dd.updatedTimestamp;
                            dd.name = (copyName.trim() === '' || copyName === undefined) ? 'No name' : copyName;
                            let pld = await dispatch(actions.createTreadmill({
                                ...dd,
                                creatorId: currentUserId
                            }));
                            setSelectedTreadmillId(pld?.treadmill?.id);
                            setCopyModalVisible(false);
                        }}>
                            Создать копию
                        </GreenButton>
                    </CopyModalInner>
                </NiceModal>
            }

        </Wrapper>
    );
}

const SelectSpan = styled.span`
  cursor: pointer;
  font-size: 12px;
  opacity: 0.7;

  :hover {
    opacity: 1;
  }
`;

const SearchPlaceholder = styled.div`
  width: 240px;
`;

const Wrapper = styled.div`

`;

const TabContent = styled.div`
  width: 100%;
  padding-top: 5px;
`;

const TopPlaceholder = styled.div`
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Quarter = styled.div`
  display: inline-block;
  vertical-align: top;
  width: calc(25% - 10px);
  margin: 5px;
  box-sizing: border-box;
  padding: 10px;
  border: 1px solid whitesmoke;
  background-color: white;
  border-radius: 3px;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }

  @media (max-width: 800px) {
    width: 50%;
  }
`;

const ModalInner = styled.div`
  width: 920px;
  box-sizing: border-box;
  padding: 5px;
  height: calc(100vh - 80px);
  max-height: calc(100vh - 80px);
  overflow-y: auto;

  @media (max-width: 720px){
    width: 75vw;
  }
`;

const Name = styled.div`
  font-weight: bold;
  font-size: 16px;
`;


const ShareLinkSpan = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: 0.75;

  :hover {
    opacity: 1;
  }
`;

const ShareExecisePlaceholder = styled.div`
  padding-top: 5px;
  padding-bottom: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-right: 5px;
  margin-top: 10px;
`;

const ShareImg = styled.img`
  margin-right: 5px;
  width: 16px;
  height: 16px;
`;

const TreadmillPlaceholder = styled.div`
  --h: calc(100vh - 250px);
  width: calc((var(--h) - 50px) * 720 / 470);
  max-width: 1152px;
  height: var(--h);
  max-height: 802px;

  @media (max-width: 1000px) {
    --w: calc(100vw - 100px);
    width: var(--w);
    height: calc((var(--w) * 470 / 720) + 50px);
  }
`;

const TreadmillControls = styled.div`
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`;

const Slider = styled.input`
  width: 100%;
  margin: 10px 0;
  cursor: pointer;
  flex: 3;
  -webkit-appearance: none;
  //overflow: hidden;
  //height: 10px;

  :hover, :focus, :active {
    outline: none;
  }

  ::-webkit-slider-runnable-track {
    //height: 2px;
    //background-color: #ff9900;
  }

  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    background-color: #FFA71B;
    width: 16px;
    height: 16px;
    border-radius: 12px;
    //box-shadow: -500px 0 0 500px dodgerblue;
  }

  ::-webkit-slider-container {
    -webkit-appearance: none;
    border-radius: 2px;
    background-color: #e1e1e1;
    height: 4px;
  }

  ::-ms-fill-lower {
    //background-color: #ff9900;
    //border-radius: 2px;
    //height: 4px;
  }
`;

const PauseButton = styled.img`
  cursor: pointer;
  opacity: 0.7;
  flex: 0;
  user-select: none;
  width: 24px;
  height: 24px;
  transform: scale(1.2);
  
  :hover {
    opacity: 1;
  }
`;

const CopyModalInner = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 20px;
  font-size: 16px;
`;

const ToggleInput = styled.input`
  height: 0;
  width: 0;
  visibility: hidden;
  user-select: none;
  :checked + label {
    background: #ff951c;
  }

  :checked + label:after {
    left: calc(100% - 1px);
    transform: translateX(-100%);
  }
`;

const ToggleLabel = styled.label`
  cursor: pointer;
  text-indent: -9999px;
  width: 40px;
  height: 20px;
  background: grey;
  display: block;
  border-radius: 100px;
  position: relative;
  user-select: none;
  :after {
    content: '';
    position: absolute;
    top: 1px;
    left: 1px;
    width: 18px;
    height: 18px;
    background: #fff;
    border-radius: 90px;
    transition: 0.3s;
  }
  
  :active:after {
    width: 26px;
  }
`;